export default {
  filter: {
    en: 'Filter',
  },
}
